import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { Validation } from './enums/validation.enum';

export const noWhitespaceValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const isWhitespace = (control.value || '').trim().length === 0;

  return isWhitespace ? { [Validation.Required]: true } : null;
};
